import store from "./store";
import VueAxios from 'vue-axios';

const axios = require('axios');

axios.interceptors.response.use((response: any) => response, (error: any) => {
  if (error.response.status === 401) {
    console.log('Error 401 - interceptor');
    // store.dispatch('logout');
  }
  return Promise.reject(error);
});
